export const PROCESSING_VOLUME_TOOLTIP =
  'ReferredPartnersStatisics/PROCESSING_VOLUME_TOOLTIP';
export const TRANSACTION_FEES_TOOLTIP =
  'ReferredPartnersStatisics/TRANSACTION_FEES_TOOLTIP';
export const TOTAL_MERCHANTS_TOOLTIP =
  'ReferredPartnersStatisics/TOTAL_MERCHANTS_TOOLTIP';
export const LOAD_STATISTICS = 'ReferredPartners/LOAD_STATISTICS';
export const SET_STATISTICS = 'ReferredPartners/SET_STATISTICS';
export const LOAD_STATISTICS_FAILED = 'ReferredPartners/LOAD_STATISTICS_FAILED';
export const SET_STATISTICS_TOTAL_TOGGLED =
  'ReferredPartners/SET_STATISTICS_TOTAL_TOGGLED';
export const SET_STATISTICS_DETAIL_TOGGLED =
  'ReferredPartners/SET_STATISTICS_DETAIL_TOGGLED';
export const TOGGLE_STATISTICS_TOTAL =
  'ReferredPartners/TOGGLE_STATISTICS_TOTAL';
export const TOGGLE_STATISTICS_DETAIL =
  'ReferredPartners/TOGGLE_STATISTICS_DETAIL';
export const SHOW_TOOLTIP = 'ReferredPartners/SHOW_TOOLTIP';

export const loadReferredPartnerStatistics = () => ({
  type: LOAD_STATISTICS
});

export const setReferredPartnerStatistics = payload => ({
  type: SET_STATISTICS,
  payload
});

export const loadReferredPartnerStatisticsFailed = () => ({
  type: LOAD_STATISTICS_FAILED
});

export const setStatisticsTotalToggled = () => ({
  type: SET_STATISTICS_TOTAL_TOGGLED
});

export const toggleStatisticsTotal = () => ({
  type: TOGGLE_STATISTICS_TOTAL
});

export const setStatisticsDetailToggled = () => ({
  type: SET_STATISTICS_DETAIL_TOGGLED
});

export const toggleStatisticsDetail = () => ({
  type: TOGGLE_STATISTICS_DETAIL
});

const initialState = {
  processing_sums: [],
  total_fees_usd: null,
  total_merchants: null,
  total_processing_vol_usd: null,
  total_referral_details: null,
  loading: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STATISTICS:
      return {
        ...state,
        processing_sums: action.payload.processing_sums,
        total_fees_usd: action.payload.total_fees_usd,
        total_merchants: action.payload.total_merchants,
        total_processing_vol_usd: action.payload.total_processing_vol_usd,
        total_referral_details: action.payload.total_referral_details,
        loading: false
      };
    case LOAD_STATISTICS_FAILED:
      return {
        ...state,
        failedLoading: true,
        loading: false
      };
    case TOGGLE_STATISTICS_TOTAL:
      return {
        ...state,
        totalToggled: !state.totalToggled
      };
    case SET_STATISTICS_TOTAL_TOGGLED:
      return {
        ...state,
        totalToggled: true
      };
    case TOGGLE_STATISTICS_DETAIL:
      return {
        ...state,
        detailToggled: !state.detailToggled
      };
    case SET_STATISTICS_DETAIL_TOGGLED:
      return {
        ...state,
        detailToggled: true
      };
    default:
      return state;
  }
};
